<template>
  <div>
    <v-menu
      ref="menu"
      v-model="menu2"
      :close-on-content-click="false"
      :return-value.sync="timeIsoLocale"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="timeIsoLocale"
          dense
          outlined
          readonly
          :disabled="disabled"
          :hide-details="hideDetails"
          :clearable="canInputBeCleared"
          :label="label"
          :prepend-inner-icon="icons.mdiClockTimeFourOutline"
          :rules="rules"
          :filled="readonly"
          v-bind="attrs"
          color="primary"
          v-on="on"
          @change="v => $emit('update:timeIso', v)"
          @click:clear="clearTimeIso"
        />
      </template>

      <v-time-picker
        v-if="menu2 && !readonly"
        v-model="timeIsoLocale"
        full-width
        format="24hr"
        :allowed-hours="allowedHours"
        :min="minTimeIso"
        :max="maxTimeIso"
        @click:minute="$refs.menu.save(timeIsoLocale)"
      />
    </v-menu>
  </div>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import { mdiClockTimeFourOutline } from '@mdi/js'
import { required } from '@/@core/utils/validation'

export default {
  emits: ['update:timeIso'],

  props: {
    timeIso: {
      type: String,
      default: null,
    },
    minTimeIso: {
      type: String,
      default: null,
    },
    maxTimeIso: {
      type: String,
      default: null,
    },
    allowedHours: {
      type: Function,
      default: null,
    },
    label: {
      type: String,
      required: true,
    },
    required: Boolean,
    readonly: Boolean,
    disabled: Boolean,
    hideDetails: Boolean,
  },

  setup(props, { emit }) {
    const timeIsoLocale = ref(null)
    const menu2 = ref(false)

    const canInputBeCleared = computed(() => !props.readonly && !props.disabled)
    const rules = computed(() => (props.required ? [required] : []))

    function clearTimeIso() {
      timeIsoLocale.value = null
      emit('update:timeIso', null)
    }

    watch(
      () => props.timeIso,
      v => {
        timeIsoLocale.value = v
      },
      {
        immediate: true,
      },
    )

    return {
      timeIsoLocale,
      menu2,
      canInputBeCleared,
      rules,
      clearTimeIso,
      icons: {
        mdiClockTimeFourOutline,
      },
    }
  },
}
</script>
